export const inputCssNoMy =
  "h-9 border px-2 rounded-md " +
  "hover:border-blue-200 hover:border-2 " +
  "focus-visible:outline-none focus-visible:border-blue-600 focus-visible:border-2 focus-visible:shadow-sm focus-visible:shadow-blue-800 " + // focus visible
  "dark:bg-her-backblue " +
  "duration-1000 transition-[box-shadow] " +
  "disabled:text-her-lightgray2 " +
  "text-base";

export const inputCss = inputCssNoMy + "my-2 ";

export const selectCssNoMy =
  "h-9 px-2 " + //
  "rounded-md border " +
  "hover:border-blue-200 hover:border-2 " +
  "text-black dark:text-her-gray dark:bg-her-backblue ";

export const selectCss = selectCssNoMy + "my-2 ";

export const textareaCss =
  "border w-full my-2 px-2 rounded-md mb-1 " +
  "hover:border-blue-200 hover:border-2 " +
  "focus-visible:outline-none focus-visible:border-blue-600 focus-visible:border-2 focus-visible:shadow-sm focus-visible:shadow-blue-800 " + // focus visible
  "dark:bg-her-backblue " +
  "duration-1000 transition-[box-shadow] ";

export const profileGridCss = "grid grid-cols-1 md:grid-cols-[200px_200px] gap-2 items-center";
